import {useContext} from "react";
import Headline from "/components/shared/Headline.jsx";
import Poster from "/components/shared/Poster.jsx";
import AppContext from "/context/AppContext";
import CardItem from "/components/shared/card/CardItem";
import RoomButton from "./buttons/RoomButton";
import {SvgTheater2} from "./SvgIcons";
import { filterHighlights } from '/utils';


export default function PosterWall() {
    const {productions} = useContext(AppContext);
    const productionsFiltered = filterHighlights(productions);


    return (
        <div className='flex justify-center'>
            <div
                className="px-4 py-4 w-fit 2xl:w-[30vw] h-fit xl:h-110 2xl:h-116 mt-[15vh] xl:mt-28 flex flex-col items-center bg-black-rgba rounded-2xl">
                <div className=''>
                    <Headline>Wir spielen online für Sie</Headline>
                    <div className="flex flex-row mt-2 justify-center items-center">
                        {productionsFiltered.slice(0, 2).map(event => (
                            <CardItem
                                key={event.slug}
                                event={event}
                            >
                            </CardItem>
                        ))}
                    </div>
                    <div className="flex flex-row justify-center items-center">
                        {productionsFiltered.slice(2, 4).map(event => (
                            <CardItem
                                key={event.slug}
                                event={event}
                            >
                            </CardItem>
                        ))}
                    </div>
                </div>
              <div className='mt-2 sm:mt-8 2xl:mt-4'>
                    <RoomButton href='/productions' className='py-2 mb-4'>
                        <div className="mr-2">{SvgTheater2()}</div>
                        Alle Stücke im Überblick
                    </RoomButton>
                </div>
            </div>
        </div>
    );
}
